import { PayloadAction } from '@reduxjs/toolkit';
import { EMPTY_STRING } from 'common/constants';
import { NOTICE_TYPES } from 'common/constants/notice';

import { IState } from '../types';
import { IProps } from '../types/notice';

const setError = (
  state: IState,
  { payload }: PayloadAction<IProps | undefined>,
) => {
  const {
    title: text = EMPTY_STRING,
    translateId = EMPTY_STRING,
    data = {},
    hideActions,
    icon,
    status,
  } = payload || {};
  state.notice = [
    {
      id: `${new Date().getTime()}`,
      text,
      translateId,
      data,
      type: NOTICE_TYPES.error,
      hideActions,
      icon,
      status,
    },
    ...(state.notice || []).slice(0, 2),
  ];
};

export default setError;
